import { AccountOpIdentifiedBy } from '@ambire-common/libs/accountOp/submittedAccountOp'
import { getBenzinUrlParams } from '@ambire-common/utils/benzin'

export const AMBIRE_EXPLORER_URL = 'https://explorer.ambire.com/'

/**
 * Build a transaction explorer link.
 *
 * Mirrors Benzin's own "Open explorer" rule (see
 * `src/benzin/screens/BenzinScreen/hooks/useBenzin/useBenzin.ts`): the gate is
 * whether we already hold an on-chain `txnId`, NOT the `identifiedBy.type`.
 *
 * - Once a `txnId` is known we have a real block-explorer-resolvable tx hash —
 *   true for plain EOA txns AND for smart-account userOps after the
 *   bundler/relayer receipt resolves the EntryPoint tx hash — so we link to the
 *   network's own explorer (e.g. PulseScan, BscScan).
 * - No `txnId` yet (pending userOp / relayer that hasn't returned a hash) →
 *   fall back to Benzin, which decodes the userOp and resolves the final hash.
 *
 * Caveat: a userOp `txnId` is only final once confirmed; clicking during the
 * brief pre-confirmation window may momentarily 404. This is the same tradeoff
 * Benzin itself accepts.
 */
export const getTransactionExplorerLink = ({
  chainId,
  txnId,
  identifiedBy,
  explorerUrl
}: {
  chainId?: string | number | bigint
  txnId?: string | null
  identifiedBy?: AccountOpIdentifiedBy
  explorerUrl?: string
}): string => {
  if (explorerUrl && txnId) {
    return `${explorerUrl.replace(/\/$/, '')}/tx/${txnId}`
  }

  return `${AMBIRE_EXPLORER_URL}${getBenzinUrlParams({ chainId, txnId, identifiedBy })}`
}
